var map = {
	"./ar.json": 5310,
	"./ca.json": 78109,
	"./de.json": 95894,
	"./en.json": 44174,
	"./es.json": 46725,
	"./hi.json": 53134,
	"./it.json": 83672,
	"./ja.json": 87980,
	"./ko.json": 19423,
	"./ru.json": 74600,
	"./zh.json": 79527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84649;